export default {
  name: "postmanservice",
  webTitle: "POST-MANSERVICE",
  primaryColor: "#FF5733",
  secondaryColor: "#FF5733",
  contactURL: "",
  hideHelpButton: true,
  bannerPrefix: "POSTMAN",
  shopCodePrefix: "PM",
  wallet: false,
  serviceName: {
    inter: false,
    lazada: false,
    dhl: false,
    shippop: false,
    shopee: false,
    doubleA: false,
    kerry: true,
    kerry_quick: false,
    kerry_orange: false,
    flash_dropoff: true,
    line: false
  },
  manageVision: {
    brancePackage: false,
    menuTopUpCreditSA: true,
  },
  unitKG: false,
  manageDisable: {
    weightSuperAdmin: false,
    dimensionSuperAdmin: false,
    costSuperAdmin: false,
  },
  dropoffKerryOption: {
    limit: 50,
  },
  customDropoffOption: {
    LZDS: {
      limit: 50,
      // manual: "https://docs.google.com/presentation/d/1gia8o9vSf5zK04MndA4jWAUnDjvL6kP-R0PoJ_TQ0TM/edit#slide=id.g25c69e5d5ed_0_5",
      // vdoHowTo: "https://drive.google.com/file/d/1_8Rh18xN8z3E6pbaoEkgDaIv7i9tB-sY/preview"
    }
  },
  dropoffFlashOption: {
    limit: 50,
    manual: "https://docs.google.com/presentation/d/1AKbsKSbDJQ_N0RZpxlWDjLZOBOwn2ah7",
    vdoHowTo: ""
  },
  btnCancelBill: false,
  bannerCampaignPosition: "DF_POSPOSTMAN",
  dropoffEasyShip: false,
  failReport: true,
  menuLayout: {
    reportInvoice: false,
  },
  LineConfig: {
    shopBank: false,
  }
};
